import { toast } from 'react-toastify'

export const handleItemAdded = () => toast(`Item has been added`)
export const handleItemUpdated = () => toast(`Item has been updated`)
